import React, { useEffect, useState } from 'react'
import BoiQuizContainer from './boiquiz/BoiQuizContainer';
import Button from '../../components/button/Button';
import { BUTTON_TYPE } from '../../components/button/constants';
import useTxNavigate from '../../../libs/txnavigate/TxNavigateHook';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setBoiGridSelectedRecords, setOpenPaymentDrawer, setPaginationState, setReferenceNumberOnFormSubmissionWithoutPayment, setReloadBoiGridRecords, setSelectedFormStatusOption, setSelectedReportingCompanyForGrid, setShowSubmitFormConfirmationPopupOnSubscription, setPayerDropdownPagination } from './ManageBoiSlice';
import Label from '../../components/label/Label';
import { LABEL_WEIGHT } from '../../components/label/constants';
import styles from './ManageBoi.styles';
import RichGrid from '../../components/richgrid/RichGrid';
import Heading from '../../components/heading/Heading';
import { HEADING } from '../../components/heading/constants/constants';
import { ROW_SELECTION_OPTIONS } from '../../components/richgrid/constants';
import { boiLifeTimePayment, deleteBoiForm, getBoiForms, getPayersList, resubmitBoi, viewPDF } from './ManageBoiSaga';
import { BOI_FORM_STATUS, BOI_FORM_STATUS_OPTIONS, BOI_QUERY_PARAMS, BOI_SINGLE_FILING_FEE_AMOUNT, BOI_SUBSCRIPTION_FILING_FEE_AMOUNT, MANAGE_BOI_LOADING_STATES, MANAGE_BOI_LOADING_STATES_MESSAGE_MAP } from './constants';
import Icons from '../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../components/icons/constants';
import PaymentDrawer from '../components/paymentdrawer/PaymentDrawer';
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../components/paymentdrawer/constants';
import BoiDataService from '../../../services/BoiDataService';
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks';
import SelectDropdown from '../../components/dropdown/selectdropdown/SelectDropdown';
import useTxSearchParams from '../../../libs/txsearchparams/TxSearchParamsHook';
import Loadable from '../../components/loadable/Loadable';
import ConfirmationPopup from '../../components/popup/confirmationpopup/ConfirmationPopup';
import { MANAGE_BOI_ROUTES } from '../constants/constants';
import InformationPopup from '../../components/popup/informationpopup/InformationPopup';

export default function ManageBoi() {
    useGarbageCollector(componentKey);

    const [showQuiz, setShowQuiz] = useState(false);
    const [formSelectedForPayment, setFormSelectedForPayment] = useState(null);
    const [isShowSubscriptionOptionPopup, setIsShowSubscriptionOptionPopup] = useState(false);
    const [isShowBOIFormNotCompletedPopup, setIsShowBOIFormNotCompletedPopup] = useState(false);
    const [boiFilingFeeAmount, setBoiFilingFeeAmount] = useState(BOI_SINGLE_FILING_FEE_AMOUNT)
    const [urlParamsHavingError, setUrlParamsHavingError] = useState(false)
    const navigate = useTxNavigate();
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { loadingState, paginationState, boiGridRecords, boiGridSelectedRecords, openPaymentDrawer, selectedFormStatusOption, selectedReportingCompanyForGrid, payersList, reloadBoiGridRecords, showSubmitFormConfirmationPopupOnSubscription, referenceNumberOnFormSubmissionWithoutPayment, payerDropdownPagination } = useSelector(state => state[componentKey])

    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    const handleGetBoiGridRecords = (pageNumber, pageSize) => {
        dispatch(getBoiForms({ ...paginationState, PageNumber: pageNumber, PageSize: pageSize, status: selectedFormStatusOption.value, payerDetailId: selectedReportingCompanyForGrid.value }));
    }

    useEffect(() => {
        dispatch(getPayersList());
    }, [])

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])
    
    useEffect(() => {
        if (payersList.length > 0) {
            const urlBoiFormStatus = queryParams.get(BOI_QUERY_PARAMS.STATUS);
            const urlReportingCompany = queryParams.get(BOI_QUERY_PARAMS.REPORTING_COMPANY);

            if (urlBoiFormStatus && urlReportingCompany) {
                const findBoiStatusFromUrl = BOI_FORM_STATUS_OPTIONS.find(item => item.value === urlBoiFormStatus);
                const findPayerFromUrl = payersList.find(item => item?.value === urlReportingCompany)

                if (findBoiStatusFromUrl && findPayerFromUrl) {
                    dispatch(setSelectedFormStatusOption(findBoiStatusFromUrl));
                    dispatch(setSelectedReportingCompanyForGrid(findPayerFromUrl));
                } else {
                    setUrlParamsHavingError(true)
                }
            } else {
                dispatch(setSelectedFormStatusOption(BOI_FORM_STATUS_OPTIONS.find(item => item.value === BOI_FORM_STATUS.NOT_SUBMITTED)));
                queryParams.set(BOI_QUERY_PARAMS.STATUS, BOI_FORM_STATUS.NOT_SUBMITTED);
                setQueryParams(queryParams);
            }
        }
    }, [payersList])

    useEffect(() => {
        if (reloadBoiGridRecords) {
            handleGetBoiGridRecords(paginationState?.PageNumber, paginationState?.PageSize);
            dispatch(setReloadBoiGridRecords(false))
        }
    }, [reloadBoiGridRecords])

    useEffect(() => {
        if (selectedFormStatusOption?.value !== "") {
            handleGetBoiGridRecords(1, paginationState?.PageSize);
            dispatch(setPaginationState({ Skip: 0, PageNumber: 1 }))
        }
    }, [selectedFormStatusOption, selectedReportingCompanyForGrid])

    const handleFormSubmit = (row) => {
        setFormSelectedForPayment(row);
        if (row?.Status.toLowerCase() === BOI_FORM_STATUS.RESUBMIT.toLowerCase()) {
            dispatch(resubmitBoi({ referenceId: row?.ReferenceID ?? 0 }))
        } else if (row?.Status.toLowerCase() === BOI_FORM_STATUS.NOT_SUBMITTED.toLowerCase()) {
            if (row?.IsRecipientReqFilled) {
                setIsShowBOIFormNotCompletedPopup(true);
            }
            else if (row?.IsSubscription) {
                dispatch(setShowSubmitFormConfirmationPopupOnSubscription(true));
            } else {
                setIsShowSubscriptionOptionPopup(true);
            }
        }
    }

    const BOI_FORMS_GRID_COLUMNS = [
        ...(selectedFormStatusOption.value === BOI_FORM_STATUS.SUBMITTED ? [{
            field: "referenceNo",
            header: <Label weight={LABEL_WEIGHT[700]}>Reference No</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{row?.ReferenceID ?? ""}</span>
        }] : []),
        {
            field: "payerName",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{row?.LastName ?? ""}</span>
        },
        {
            field: "taxId",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{row?.IdNumber ?? ""}</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{row?.Status ?? ""}</span>
        },
        {
            field: "actions",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Actions</Label>,
            renderLogic: (row, idx) => <div style={styles.gridActions}>
                <Loadable currentState={loadingState.state} loadingStates={[`${MANAGE_BOI_LOADING_STATES.VIEW_PDF_LOADING}-${row?.FormRecordId}`]} messageMap={MANAGE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                    <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'View Form'} onClickCb={() => dispatch(viewPDF({ formRecordId: row?.FormRecordId }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                </Loadable>
                {
                    [BOI_FORM_STATUS.NOT_SUBMITTED.toLowerCase()].includes(row?.Status.toLowerCase()) &&
                    <>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Delete Form'} onClickCb={() => dispatch(deleteBoiForm({ formRecordId: row?.FormRecordId }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>
                    </>
                }
                {[BOI_FORM_STATUS.NOT_SUBMITTED.toLowerCase(), BOI_FORM_STATUS.RESUBMIT.toLowerCase()].includes(row?.Status.toLowerCase()) &&
                    <>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit Form'} onClickCb={() => navigate(`/boireporting/fileboi?FormRecordId=${row?.FormRecordId}`)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} /></Button>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Submit Form'} onClickCb={() => handleFormSubmit(row)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.SUBMIT_PAYMENT_ICON} /></Button>
                    </>
                }
            </div>
        },
    ]

    return <>
        <Heading type={HEADING.H2}>FinCEN BOI</Heading>
        <Loadable currentState={loadingState.state} loadingStates={[MANAGE_BOI_LOADING_STATES.MANAGE_BOI_FORMS_PAGE_LOADING]} messageMap={MANAGE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
            {
                !urlParamsHavingError ? <>
                    <div style={styles.fileBoiDiv}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => navigate(`/${MANAGE_BOI_ROUTES.BOI_REPORTING}/${MANAGE_BOI_ROUTES.FILE_BOI}`)}>File BOI</Button>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => setShowQuiz(true)}>Not sure if you should file? Take the quiz</Button>
                    </div>
                    <div style={styles.filtersContainer}>
                        <SelectDropdown
                            label="Status"
                            name="status"
                            placeHolder="Please select status"
                            value={selectedFormStatusOption}
                            options={BOI_FORM_STATUS_OPTIONS}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedFormStatusOption(selectedOption));
                                queryParams.set(BOI_QUERY_PARAMS.STATUS, selectedOption?.value);
                                setQueryParams(queryParams);
                            }}
                            isClearable={false}
                        />
                        <Loadable currentState={loadingState.state} loadingStates={[MANAGE_BOI_LOADING_STATES.PAYERS_LIST_LOADING]} messageMap={MANAGE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                            <SelectDropdown
                                label="Reporting Company"
                                name="reportingCompany"
                                placeHolder="Please select reporting company"
                                value={selectedReportingCompanyForGrid}
                                options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                                onDropdownTouchedToBottomCb={() => {
                                    if(payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length){   
                                        dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                    }
                                }}
        
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedReportingCompanyForGrid(selectedOption));
                                    queryParams.set(BOI_QUERY_PARAMS.REPORTING_COMPANY, selectedOption?.value);
                                    setQueryParams(queryParams);
                                }}
                                isClearable={true}
                            />
                        </Loadable>
                    </div>
                    <Loadable currentState={loadingState.state} loadingStates={[MANAGE_BOI_LOADING_STATES.GRID_LOADING]} messageMap={MANAGE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                        <RichGrid
                            selectable={true}
                            showHeaderSelectionCheckbox={false}
                            data={boiGridRecords}
                            columns={BOI_FORMS_GRID_COLUMNS}
                            extractRowKey={(row) => row?.FormRecordId}
                            selectedRows={boiGridSelectedRecords}
                            onSelectionChangeCallBack={(selectedData) => dispatch(setBoiGridSelectedRecords(selectedData))}
                            paginationProps={{
                                skip: paginationState?.Skip,
                                take: paginationState?.PageSize,
                                takeOptions: ROW_SELECTION_OPTIONS,
                                onChangeTakeCb: (newTake) => {
                                    dispatch(setPaginationState({ PageSize: newTake, Skip: 0, PageNumber: 1 }))
                                    handleGetBoiGridRecords(1, newTake)
                                },
                                total: paginationState?.totalRecords,
                                onChange: (take, t) => {
                                    dispatch(setPaginationState({ PageSize: take, Skip: t, PageNumber: (t / take) + 1 }))
                                    handleGetBoiGridRecords((t / take) + 1, take)
                                },
                            }}
                        />
                    </Loadable>
                </>
                    : <p>No records matching your searched parameters or there was an error in parameters. Please try again.</p>
            }


        </Loadable>

        {showQuiz && <BoiQuizContainer isPopupOpen={showQuiz} onCloseCb={() => setShowQuiz(false)} />}
        {
            openPaymentDrawer && <PaymentDrawer
                isOpen={openPaymentDrawer}
                onCloseCb={() => {
                    dispatch(setOpenPaymentDrawer(false))
                }}
                fees={{
                    OnlySeparateStatefiling: "false",
                    TotalFilingFee: boiFilingFeeAmount,
                    FilingFee: boiFilingFeeAmount,
                }}
                calculatePrepaySalesTax={true}
                paymentServiceFunctionCb={BoiDataService.BoiPayment}
                onPaymentSuccessCb={() => {
                    handleGetBoiGridRecords(paginationState?.PageNumber, paginationState?.PageSize);
                }}
                placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.BOI_FORM_PAYMENT}
                paymentServiceFunctionExtraParams={{
                    formRecordId: formSelectedForPayment?.FormRecordId,
                    IsSubscription: boiFilingFeeAmount === BOI_SUBSCRIPTION_FILING_FEE_AMOUNT ? true : false,
                }}
            />
        }
        {
            isShowSubscriptionOptionPopup && <ConfirmationPopup
                title={"Plan Payment"}
                bodyText={"Select a package offer before you proceed"}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={isShowSubscriptionOptionPopup}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        setBoiFilingFeeAmount(BOI_SINGLE_FILING_FEE_AMOUNT)
                        dispatch(setOpenPaymentDrawer(true));
                        setIsShowSubscriptionOptionPopup(false)
                    },
                    confirmationButtonText: `Pay for this single form - $${BOI_SINGLE_FILING_FEE_AMOUNT}`,
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        setBoiFilingFeeAmount(BOI_SUBSCRIPTION_FILING_FEE_AMOUNT)
                        dispatch(setOpenPaymentDrawer(true));
                        setIsShowSubscriptionOptionPopup(false);
                    },
                    cancelButtonText: `Unlimited lifetime free filing subscription for 1 business/EIN - $${BOI_SUBSCRIPTION_FILING_FEE_AMOUNT}`,
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    onCloseCb: () => {
                        setIsShowSubscriptionOptionPopup(false);
                    },
                }}
                showClose={true}
                isClose={false}
                customStyle={styles.confirmationPopupCustomStyle}
            />
        }
        {
            <InformationPopup
                title={"Select All Action"}
                bodyText={"Please complete the BOI request for selected form."}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={isShowBOIFormNotCompletedPopup}
                confirmationButtonProps={{
                    onConfirmationCb: () => (setIsShowBOIFormNotCompletedPopup(false)),
                    confirmationButtonText: "Ok",
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                showClose={false}
            />
        }

        {
            showSubmitFormConfirmationPopupOnSubscription && <ConfirmationPopup
                title={"No payment required"}
                bodyText={"As you have a subscription plan, this form will be directly submitted and no payment will be deducted. Do you want to proceed?"}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showSubmitFormConfirmationPopupOnSubscription}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(boiLifeTimePayment({ formRecordId: formSelectedForPayment?.FormRecordId }));
                    },
                    confirmationButtonText: `Ok`,
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setShowSubmitFormConfirmationPopupOnSubscription(false))
                    },
                    cancelButtonText: `Cancel`,
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                showClose={false}
            />

        }
        {referenceNumberOnFormSubmissionWithoutPayment && <ConfirmationPopup
            title={"Success"}
            bodyText={`Your submission is successful. Reference number is ${referenceNumberOnFormSubmissionWithoutPayment}`}
            iconName={VEC_ICON_NAME.WARNING_ICON}
            isOpen={referenceNumberOnFormSubmissionWithoutPayment}
            confirmationButtonProps={{
                onConfirmationCb: () => {
                    dispatch(setReferenceNumberOnFormSubmissionWithoutPayment(null))
                },
                confirmationButtonText: `Ok`,
                confirmationButtonStyles: {},
                confirmationButtonType: BUTTON_TYPE.PRIMARY,
            }}
            showClose={false}
        />}

    </>
}